import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import AIAgentWidget from "@/components/AIAgentWidget";
import { useAuth } from "@/App";
import { useNotificationSocket } from "@/hooks/useNotificationSocket";

const MainLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { user } = useAuth();
  useNotificationSocket(user);

  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-slate-950">
      <Sidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />
      <div className="flex-1 flex flex-col min-h-screen overflow-hidden">
        <Topbar onMenuToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
        <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto dark:text-white">
          <Outlet />
        </main>
      </div>
      <AIAgentWidget />
    </div>
  );
};

export default MainLayout;
